import React, { useEffect } from "react";
import decorationTop from "../../assets/decoration (1).png";
import decorationBottom from "../../assets/decoration.png";
import FormSubmitButton from "../Atoms/FormButton/FormSubmitButton";
import { FaDownload } from "react-icons/fa";

const DeepLinkHandler = () => {
  const appSchemeBase = "Eyision://";
  const playStoreURL =
    "https://play.google.com/store/apps/details?id=com.app.eysion";
  const appStoreURL = "https://apps.apple.com/in/app/eyision/id6749613401";

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const screen = params.get("screen") || "home";
    const id = params.get("id");

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      const appScheme = `${appSchemeBase}${screen}${id ? `?id=${id}` : ""}`;
      window.location.href = appScheme;

      setTimeout(() => {
        const isAndroid = /Android/i.test(navigator.userAgent);
        window.location.href = isAndroid ? playStoreURL : appStoreURL;
      }, 2000);
    }
  }, [appSchemeBase, playStoreURL, appStoreURL]);

  return (
    <div className="relative w-full min-h-screen bg-[#d7becf] flex items-center justify-center overflow-hidden">
      <img
        src={decorationBottom}
        alt="Bottom Decoration"
        className="absolute bottom-0 left-0 max-w-[300px] w-full pointer-events-none select-none"
      />
      <img
        src={decorationTop}
        alt="Top Decoration"
        className="absolute top-0 right-0 max-w-[500px] w-full pointer-events-none select-none"
      />

      <div className="w-full lg:max-w-[500px] max-w-[800px] bg-white p-6 sm:p-8 md:p-9 rounded-md z-10">
        <div className="flex flex-col gap-6 sm:gap-9">
          <div className=" flex items-center justify-center">
            <img
              src="/newLogo.png"
              alt="sign_image"
              className="object-cover w-44"
            />
          </div>

          <div style={{ textAlign: "center", marginTop: "2rem" }}>
            <h1 className="text-lg font-semibold mb-4">
              Opening Eyision App...
            </h1>
            <p className="mb-6">
              If it does not open automatically, use the buttons below:
            </p>

            <div className="flex justify-center">
              <a href={`${appSchemeBase}home`} className="w-40">
                <FormSubmitButton buttonLabel="Open in App" type="button" />
              </a>
            </div>

            <div className="flex gap-3 items-center justify-center mt-4">
              <a href={playStoreURL} target="_blank" rel="noopener noreferrer">
                <FormSubmitButton
                  buttonLabel={
                    <>
                      <FaDownload className="inline mr-2 text-lg" />
                      Download for Android
                    </>
                  }
                  type="button"
                />
              </a>

              <a href={appStoreURL} target="_blank" rel="noopener noreferrer">
                <FormSubmitButton
                  buttonLabel={
                    <>
                      <FaDownload className="inline mr-2 text-lg" />
                      Download for iOS
                    </>
                  }
                  type="button"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeepLinkHandler;
